import React, { useContext } from 'react'
import classNames from 'classnames'
import { string, object, array, bool } from 'prop-types'
import { AdSlot } from 'react-dfp'
import generateAdUnitPath from './ad-unit-path-generator'

import { RowContext } from '@/component/Context/RowContext'

import styles from './Advert.module.scss'

const Advert = ({
  slotName,
  size,
  suffix,
  keyValueTargeting,
  alignment,
  section,
  article,
  hasBackground,
  pageData,
  className
}) => {
  const advertSiteId = pageData?.advertSiteId
  const adUnitPath = generateAdUnitPath(
    slotName,
    size,
    suffix,
    section,
    article,
    advertSiteId
  )

  const inverseRow = useContext(RowContext)
  const h = Number(size?.split('x')?.[1])
  const height = isNaN(h) ? 'unset' : `${h}px`

  return (
    <div
      className={classNames(
        styles.Advert,
        hasBackground && styles.Background,
        alignment && styles[alignment],
        styles[`s-${size}`],
        inverseRow && styles.inverse,
        className
      )}
      style={{ height }}
    >
      <AdSlot
        slotId={slotName}
        sizes={size ? [size.split('x').map(Number)] : []}
        adUnit={adUnitPath}
      />
    </div>
  )
}

Advert.defaultProps = {
  alignment: 'center'
}

Advert.propTypes = {
  slotName: string,
  size: string,
  suffix: string,
  keyValueTargeting: array,
  alignment: string,
  section: object,
  article: object,
  hasBackground: bool,
  pageData: object,
  className: string
}

export default Advert
